document.addEventListener('DOMContentLoaded', function() {
    function adjustHeaderPadding() {
				const debug_enabled = false;
        try {
           // Exit early if body has 'use-green-menu' class
            if (document.body.classList.contains('use-green-menu')) {
                debug_enabled && console.log('[Header Padding]: Exiting early due to use-green-menu class');
                return;
            }

						// Get the site header element
            const siteHeader = document.querySelector('header.site-header');

            if (!siteHeader) {
                debug_enabled && console.warn('Site header element not found');
                return;
            }

            // Get the site header height
            const headerHeight = siteHeader.offsetHeight;
            const additionalPadding = 90
            const totalPadding = headerHeight + additionalPadding;

						// Scenario 0: For events archive page (maybe others too, not sure yet: padding is applied to main.site-inner > .wrap first child .archive-description
	          // Done first because otherwise the next one catches the first event, which we don't want.
            const archiveDescription = document.querySelector('.post-type-archive-event.archive main.site-inner > .wrap .archive-description');
            if (archiveDescription) {
                const computedDisplay = window.getComputedStyle(archiveDescription).display;
                archiveDescription.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to archive-description`);
                return;
            }

            // Scenario 1: Try article entry header's first child, but not if it's the event archive page
            const articleEntryHeader = document.querySelector('.content-sidebar-wrap > .content > article .entry-header');
            if (articleEntryHeader && articleEntryHeader.firstElementChild) {
                articleEntryHeader.firstElementChild.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to first child of article entry header`);
                return;
            }

            // Scenario 2: Try direct entry header's first child
            const directEntryHeader = document.querySelector('.content-sidebar-wrap > .content > .entry-header');
            if (directEntryHeader && directEntryHeader.firstElementChild) {
                directEntryHeader.firstElementChild.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to first child of direct entry header`);
                return;
            }

            // Scenario 3: Try direct entry header itself
            if (directEntryHeader) {
                directEntryHeader.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to direct entry header itself`);
                return;
            }

            // Scenario 4: Try archive title
            const archiveTitle = document.querySelector('.content-sidebar-wrap > .content > .archive-title');
            if (archiveTitle) {
                archiveTitle.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to archive title`);
                return;
            }

            // Scenario 5: Try wp-block-cover if it's first child of entry-content
            const entryContent = document.querySelector('.content-sidebar-wrap > .content .entry-content');
            if (entryContent && entryContent.firstElementChild && entryContent.firstElementChild.classList.contains('wp-block-cover')) {
                entryContent.firstElementChild.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to first wp-block-cover in entry-content`);
                return;
            }

						// Scenario 6: Try main.site-inner > .wrap first child, but not
            const siteInnerWrap = document.querySelector('main.site-inner > .wrap');
            if (siteInnerWrap && siteInnerWrap.firstElementChild) {
                const firstChild = siteInnerWrap.firstElementChild;
                const computedDisplay = window.getComputedStyle(firstChild).display;

                // Check if current display type doesn't support padding
                if (computedDisplay === 'inline') {
                    firstChild.style.display = 'block';
                    debug_enabled && console.log('Changed display to block for padding support');
                }

                firstChild.style.paddingTop = `${totalPadding}px`;
                debug_enabled && console.log(`Applied padding-top of ${totalPadding}px to first child of site-inner wrap`);
                return;
            }

            // If none of the elements were found
            debug_enabled && console.warn('No matching elements found for padding adjustment');

        } catch (error) {
            debug_enabled && console.error('Error adjusting padding:', error);
        }
    }

    // Initial adjustment
    adjustHeaderPadding();

    // Adjust on window resize to handle responsive layouts
    window.addEventListener('resize', adjustHeaderPadding);
});
